import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AiOutlineLeft } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { trimString } from '../Helpers/Common';
import { Card, SubNavBarActiveDiv, SubNavBarNormalDiv, TextBlack, NavActiveLink, ButtonCommonTop, SubNavBarActiveDot, SubNavBarNormalDot } from '../../pages/Theme';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const SubNavbar = ({ menuLinks, aside, isGroupFeed }) => {
    const location = useLocation();
    const history = useHistory();

    const isDefaultTheme = useSelector(state => state.auth.isDefaultTheme);

    const Tablink = ({ text, count, active, url }) => {
        let style = 'py-2 mr-3 px-4 pb-1 w-max font-bold text-lg md:text-lg flex h-full items-center nav-navigate cursor-pointer sub-link';
        return (
            active ?
                <div className="px-3 ">
                    <SubNavBarActiveDiv className='h-full flex justify-center items-center border-b-2'>
                        <Link to={url} className={`${style}`}>
                            <SubNavBarActiveDiv className='flex'>
                                <span><div className='flex items-center'><SubNavBarActiveDot />{text}</div></span>{(count > 0) && <span className={`${count?.toString().length > 2 ? "text-xs" : "text-lg"} relative  left-2 flex items-center justify-center w-7 h-7 font-semibold text-white rounded-full  mr-3`} style={{ backgroundColor: "red" }}>{count}</span>}
                            </SubNavBarActiveDiv>
                        </Link>
                    </SubNavBarActiveDiv>
                </div> :
                <div className='h-full flex justify-center items-center px-3'>
                    <SubNavBarNormalDiv>
                        <Link to={url} className={`${style} ${'hover:border-b-2'}`}>
                            <SubNavBarNormalDiv className='flex'>
                                <span><div className='flex items-center'><SubNavBarNormalDot />{text}</div></span>{(count > 0) && <span className={`${count?.toString().length > 2 ? "text-xs" : "text-lg"} relative  left-2 flex items-center justify-center w-7 h-7 font-semibold text-white rounded-full  mr-3`} style={{ backgroundColor: "red" }}>{count}</span>}
                            </SubNavBarNormalDiv>
                        </Link>
                    </SubNavBarNormalDiv>
                </div >
        )
    }

    const TablinkDefault = ({ text, count, active, url }) => {
        let style = (active ? 'blueColor blueBorderColor' : 'greyColor border-transparent');
        style += ' py-2 mr-3 px-4 pb-1 w-max font-bold text-lg md:text-lg flex h-full items-center border-b-2 hover:no-underline hover:text-black'
        let dotStyle = ` w-1.5 h-1.5 mr-3 rounded-full ${active ? ' blueBackGroundColor' : 'greyBackGroundColor'}`;
        return (
            <div className='h-full flex justify-center items-center'>
                <Link to={url} className={style}>
                    <span><div className='flex items-center'><div class={dotStyle}></div>{text}</div></span>{(count > 0) && <span className={`${count?.toString().length > 2 ? "text-xs" : "text-lg"} relative  left-2 flex items-center justify-center w-7 h-7 font-semibold text-white rounded-full  mr-3`} style={{ backgroundColor: "red" }}>{count}</span>}
                </Link>
            </div>
        )
    }


    return (
        <div>
            <Card className='border-bottom-f1 flex flex-wrap pt-5 pb-5 flex-row justify-between bg-white w-full border20px borderBottomradius0px'>
                <div className='flex h-full w-max justify-start overflow-x-auto no-scrollbar px-6'>
                    {isGroupFeed ?
                        <Link to={'/community/groups'} className="nav-navigate">
                            {/* <div onClick={() => history.push((menuLinks.length !== 0 && menuLinks[0].url) ? menuLinks[0].url : '/community/groups', { src: location.pathname })}> */}
                            <TextBlack className="py-5 md:py-10 w-max ml-5 md:ml-12 text-2xl md:text-4xl font-bold 
                                                    break-words cursor-pointer flex flex-row space-x-5 items-center hover:underline"
                            >
                                <AiOutlineLeft className='w-10 h-10' />
                                <h1>
                                    {trimString(menuLinks[0].title, 50)}
                                </h1>
                            </TextBlack>
                            {/* </div> */}
                        </Link>
                        :
                        menuLinks.map((menu, idx) => (
                            isDefaultTheme === false ?
                                <Tablink
                                    key={idx}
                                    text={menu.title}
                                    count={menu.count}
                                    active={location.pathname === menu.url}
                                    url={menu.url}
                                /> :
                                <TablinkDefault
                                    key={idx}
                                    text={menu.title}
                                    count={menu.count}
                                    active={location.pathname === menu.url}
                                    url={menu.url}
                                />
                        ))
                    }
                </div>
                {aside &&
                    <div className='hidden pr-5 lg:block flex w-max items-center  self-end self-center'>
                        {aside}
                    </div>
                }
            </Card>
        </div>
    )
}

export default SubNavbar;